export const isBrowser = (): boolean => {
  return Boolean(
    typeof window !== 'undefined' && typeof window.document !== 'undefined',
  );
};
